// src/pages/EmployeeDashboard.js
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import axios from 'axios';
import DashboardShell from '../components/dashboard/DashboardShell';
import UpcomingTrainingsWidget from '../components/dashboard/employee/UpcomingTrainingsWidget';
import CompletedTrainingsWidget from '../components/dashboard/employee/CompletedTrainingsWidget';
import MissedTrainingsWidget from '../components/dashboard/employee/MissedTrainingsWidget';
import QuickLinksWidget from '../components/dashboard/employee/QuickLinksWidget';
import MessageBoardWidget from '../components/dashboard/MessageBoardWidget';
import { getUser } from '../utils/auth';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function EmployeeDashboard() {
  const user = getUser();
  const [data, setData] = useState({ upcoming: [], completed: [], missed: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchDashboard = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/trainings/trainings.php`, {
          params: { user_id: user.id },
          withCredentials: true
        });
        if (isMounted) {
          setData({
            upcoming: response.data.upcoming || [],
            completed: response.data.completed || [],
            missed: response.data.missed || []
          });
        }
      } catch (error) {
        console.error('There was an error fetching the dashboard trainings!', error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchDashboard();
    return () => { isMounted = false; };
  }, [user.id]);

  return (
    <DashboardShell title={`Welcome, ${user.name}`} subtitle="Here's what's happening with your training">
      <Row className="g-3">
        <Col lg={8}>
          <Row className="g-3">
            <Col md={12}>
              <UpcomingTrainingsWidget trainings={data.upcoming} loading={loading} />
            </Col>
            <Col md={6}>
              <CompletedTrainingsWidget trainings={data.completed} loading={loading} />
            </Col>
            <Col md={6}>
              <MissedTrainingsWidget trainings={data.missed} loading={loading} />
            </Col>
          </Row>
        </Col>
        <Col lg={4}>
          <Row className="g-3">
            <Col md={12}>
              <MessageBoardWidget />
            </Col>
            <Col md={12}>
              <QuickLinksWidget userId={user.id} />
            </Col>
          </Row>
        </Col>
      </Row>
    </DashboardShell>
  );
}

export default EmployeeDashboard;
